export default __webpack_public_path__ + "static/media/IMG_0687.f6a30c65.f6a30c65.JPG";